import axios from "axios";

const CMS_BASE_URL = `${process.env.REACT_APP_CMS_BASEURL}`;
const LUNG_CARE_API_URL = `${process.env.REACT_APP_LUNGSCARE}`;

export function getLungsCareMainData() {


  // return axios.get(`${CMS_BASE_URL}lungscare-news?populate=first,second,second.secsub,third,third.thirdsub,fourth,fourth.fourthsub,fifth,fifth.headline,fifth.fifthsub,sixth,sixth.sixthsub,seventh,seventh.sevensub,seventh.sevensub.points`, 
  // );

  return axios.get(`${CMS_BASE_URL}lungscare-news?populate=first,third,third.thirdsub,fourth,fourth.fourthsub,fifth,fifth.fifthsub,sixth,sixth.sixthsub`, 
  );
 
 
}


/**

 * @param {FormData} formData  — should already have your blob under “file”
 */
export function postLungscareImageReport(formData) {
  return axios.post(
    `${LUNG_CARE_API_URL}predict/`,
    formData,
    {
      headers: {
        // Let Axios set the correct boundary for you
        "Content-Type": "multipart/form-data",
      },
    }
  );
}

// Single-request alternative to paginating get_report_list — read-only lookup of
// one lung care submission by its request_id (ORDERID in the get_report_list row).
// STATUS: 0 queued, 3 backend accepted/processing, 1 done, 2 failed.
export function getLungcareStatus(requestId, patientid) {
  const url = new URL(`lungcare-status/${requestId}`, process.env.REACT_APP_QUANTUMURL).toString();
  return axios.get(url, { params: { patientid } });
}
